import { SetFilters, SetFiltersObject, SetInitialFilters } from '~/constants/actions';
import { SetQueryValue } from '~/constants/mutations';
import { GetFilters, GetSearchQuery } from '~/constants/getters';

const defaultState = () => {
  return {
    formFilters: {},
    queryValue: '',
  };
};

const state = defaultState();

const mutations = {
  [SetQueryValue](state, value) {
    state.queryValue = value;
  },

  [SetFilters](state, { key, value }) {
    if (!value) {
      const { [key]: removed, ...rest } = state.formFilters;
      state.formFilters = rest;
    } else {
      if (!state.formFilters[key] || state.formFilters[key] !== value) {
        state.formFilters = { ...state.formFilters, [key]: value };
      }
    }
  },
  [SetFiltersObject](state, filters) {
    state.formFilters = { ...filters };
  },
  [SetInitialFilters](state) {
    state.formFilters = {};
  },
};

const getters = {
  [GetFilters](state) {
    return state.formFilters;
  },
  [GetSearchQuery](state) {
    return state.queryValue;
  },
};

const actions = {
  [SetQueryValue]: ({ commit }, value) => {
    commit(SetQueryValue, value);
  },
  [SetFilters]: ({ commit }, data) => {
    commit(SetFilters, data);
  },
  [SetInitialFilters]: ({ commit }) => {
    commit(SetInitialFilters);
  },
  [SetFiltersObject]: ({ commit }, filters) => {
    commit(SetFiltersObject, filters);
  },
};

export default {
  namespaced: true, // Important for namespacing module
  state,
  mutations,
  actions,
  getters,
};
